import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import * as Yup from 'yup';
import type { ReactSelectOption } from '../../../types/Constants';
import type { FiltersInterface } from '../../../types/Miscellaneous';
import Button from '../../UI/Button';

import { HookForm } from '../../UI/HookForm/Form';
import { HookReactSingleSelect } from '../../UI/HookForm/Form/ReactSelect';
import { HookFormProvider } from '../../UI/HookForm/Provider';
import Modal from '../../UI/Modal';

interface IProjectSortModalData {
  order: ReactSelectOption;
  orderBy: ReactSelectOption;
}

const validationSchema = Yup.object({
  order: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  }).test('order', 'Required', (val) => {
    return val.label !== undefined && val.value !== undefined;
  }),
  orderBy: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  }).test('orderBy', 'Required', (val) => {
    return val.label !== undefined && val.value !== undefined;
  }),
});

export default function ProjectSortModal({
  handleModal,
  applyFiltersHandler,
  handleDisplayFilters,
}: {
  handleModal: () => void;
  applyFiltersHandler: (filters: FiltersInterface) => void;
  handleDisplayFilters: (filters: any) => void;
}) {
  const [filters, setFilters] = useState<FiltersInterface>({});

  const filterSubmitHandler = (formData: IProjectSortModalData) => {
    const selectedFilters: FiltersInterface = {
      order: formData.order.value,
      orderBy: formData.orderBy.value,
    };

    setFilters(selectedFilters);
    applyFiltersHandler(selectedFilters);

    handleDisplayFilters({
      orderBy: {
        label: 'Sort',
        value: `${formData?.orderBy?.label}(${formData?.order.label})`,
      },
    });
    handleModal();
  };

  return (
    <Modal>
      <HookFormProvider defaultValues={filters} resolver={yupResolver(validationSchema) as any} mode='all'>
        <HookForm onSubmit={filterSubmitHandler}>
          <h2 className='text-primaryColor-normal mt-0'>Sort Projects</h2>
          <section className='space-y-5'>
            <HookReactSingleSelect
              label='Sort By'
              name='orderBy'
              componentClassName='grid grid-cols-2'
              options={[
                { label: 'Project Name', value: 'name' },
                { label: 'Street Address', value: 'address' },
              ]}
            />
            <HookReactSingleSelect
              label='Sort Order'
              name='order'
              componentClassName='grid grid-cols-2'
              options={[
                { label: 'Ascending', value: 'asc' },
                { label: 'Descending', value: 'desc' },
              ]}
            />

            <div className='flex flex-row mt-8 w-full justify-end items-center space-x-5'>
              <Button label='Cancel' btnStyle='btn-neutral' btnType='button' onClick={handleModal} />
              <Button label='Apply' btnStyle='btn-primary' btnType='Submit' />
            </div>
          </section>
        </HookForm>
      </HookFormProvider>
    </Modal>
  );
}
